import { useEffect, useState } from 'react';

/** Aligns with Ant Design `lg` and existing layout media queries. */
export const COMPACT_LAYOUT_MAX = 991;
export const MOBILE_LAYOUT_MAX = 767;

const getMatches = (query: string): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.matchMedia(query).matches;
};

const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => getMatches(query));

  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    setMatches(media.matches);

    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    }

    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, [query]);

  return matches;
};

/** True when viewport is tablet/mobile (&lt; 992px) — use Drawer instead of Sider. */
export const useIsCompactLayout = (): boolean =>
  useMediaQuery(`(max-width: ${COMPACT_LAYOUT_MAX}px)`);

/** True when viewport is mobile (&lt; 768px). */
export const useIsMobileLayout = (): boolean =>
  useMediaQuery(`(max-width: ${MOBILE_LAYOUT_MAX}px)`);

export default useIsCompactLayout;
